import * as homeApis from 'apis/home';
import _ from 'lodash';

const state = {
  homePageData: [],
  tabData: [],
  fromSource: '',
};

const mutations = {
  changeHomePageData(state, value) {
    state.homePageData = value;
  },
  changeTabData(state, value) {
    state.tabData = value;
  },
  changeFrom(state, value) {
    state.fromSource = value;
  },
};

const getters = {};

const actions = {
  async fetchTabtData({ commit }, page) {
    let data = null;
    if (page !== 'home' && (!state.homePageData || !state.homePageData.length)) {
      data = await homeApis.getHomeModuleData({ isCache: 0 });
      commit('changeHomePageData', data);
    } else {
      data = state.homePageData;
    }
    if (Array.isArray(data)) {
      const tabData = data.filter(v => v.module_type === 15);
      if (!_.isEmpty(tabData)) {
        tabData.forEach((v) => {
          if (v.module_name === '首页') {
            v.path = 'home';
          } else if (v.module_name === '分类') {
            v.path = 'class';
          } else if (v.module_name === '购物车') {
            v.path = 'cart';
          } else if (v.module_name === '我') {
            v.path = 'my';
          }
        });
        commit('changeTabData', tabData);
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
